import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqAccordion({ items, testidPrefix = "faq-accordion" }) {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="divide-y divide-slate-200 overflow-hidden rounded-3xl bg-white shadow-crystal">
      {items.map((item, i) => {
        const open = openIdx === i;
        const q = item.q || item.question;
        const a = item.a || item.answer;
        return (
          <div key={i} data-testid={`${testidPrefix}-${i}`}>
            <button
              onClick={() => setOpenIdx(open ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition hover:bg-tosca-50/50 sm:px-7"
              aria-expanded={open}
            >
              <span className="font-heading text-sm font-bold text-charcoal sm:text-base">{q}</span>
              <span className={`inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-all duration-300 ${open ? "rotate-45 bg-gold text-charcoal" : "bg-tosca-50 text-tosca-600"}`}>
                <Plus className="h-4 w-4" />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-5 pb-6 text-sm leading-relaxed text-slate-500 sm:px-7">{a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
